import React from 'react';
import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import './AppSidebar.css';

export default function WorkflowShell() {
  return (
    <div className="workflow-shell">
      <AppSidebar />
      <div className="workflow-shell__main">
        <Outlet />
      </div>
    </div>
  );
}
